import React from "react";
import { useDispatch, useSelector } from "react-redux";
import sharedGlobals from "../../sharedglobals";
import Footer from "../Footer";
import Notification from "../Notification";
//import * as userActions from '../modules/userprofile/actions/userprofileactions'
import * as userActions from '../../modules/userprofile/actions/userprofileactions'
import * as appUtilityFunction from '../../infrastructure/apputilityfunctions';

export default function TopBar() {
  const dispatch = useDispatch();
  const gotoHome = () => {
    window.location.href = sharedGlobals.appUrls.ssoUrl + 'dashboard'
  }
  const userSession = useSelector(state => state.securityReducer.userSession);
  const signout = () => {
    dispatch(userActions.signOutUser());
  }
  return (

    <>
      {/*!-- Topbar Start --*/}
      <div class="navbar-custom">
        <ul class="list-unstyled topbar-menu float-end mb-0">

          <li class="dropdown notification-list d-none d-sm-inline-block">
            <a
              class="nav-link dropdown-toggle arrow-none"
              data-bs-toggle="dropdown"
              href="#"
              onClick={() => gotoHome()}
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
            >
              <i class="dripicons-home noti-icon"></i>
            </a>
          </li>

            <Notification />


          <li class="dropdown notification-list">
            <a class="nav-link dropdown-toggle nav-user arrow-none me-0" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false"
              aria-expanded="false">
              <span class="account-user-avatar">
                <img src="content/theme/assets/images/avatar1.png" alt="user-image" class="rounded-circle" />
              </span>
              <span>
              <span class="account-user-name">{userSession &&  appUtilityFunction.trimText(userSession.displayName, 13)} </span>
                <span class="account-position">Employee</span>
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown">

              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">Welcome !</h6>
              </div>
              <a
                href='/'
                className="dropdown-item notify-item"
              >
                <i className="mdi mdi-chart-areaspline"> </i>
                <span> Dashboard</span>
              </a>

              <a href="/userprofile" class="dropdown-item notify-item">
                <i class="mdi mdi-account-edit me-1"></i>
                <span>Settings</span>
              </a>


              <a href="javascript:void(0);" class="dropdown-item notify-item">
                <i class="mdi mdi-lifebuoy me-1"></i>
                <span>Support</span>
              </a>

              <a type="button" class="dropdown-item notify-item" onClick={() => signout()}>
                <i class="mdi mdi-logout me-1"></i>
                <span>Logout</span>
              </a>

            </div>
          </li>


        </ul>
        <button class="button-menu-mobile open-left disable-btn">
          <i class="mdi mdi-menu"></i>
        </button>
      </div>

    </>

  )
}
